export const AIR = 'air'
export const HOTEL = 'hotel'
export const TRAIN = 'train'
export const CAR = 'car'
export const OTHER = 'other'
export const TRAIN_SEGMENT = 'train_segment'
export const TRAIN_PASSES = 'train_passes'

export const BILLING = 1
export const PRICE = 2
export const PAYMENT_METHOD = 3
export const LIQUIDATION = 7
export const INSTALLMENT_METHOD = 5
export const PAYMENT_CHARGE = 6
export const SETTING = 4
export const CONTENT = 8


export const OTHER_DETAIL = 'other_detail'
export const PRODUCT_TYPE_OTHER_ID = 77777